import { render, staticRenderFns } from "./DateDisplay.vue?vue&type=template&id=096bd2ee&"
import script from "./DateDisplay.vue?vue&type=script&lang=js&"
export * from "./DateDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DateDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports